import {
    Button,
    Card,
    Spin,
    useTable,
    Table,
    TextField,
    TableProps,
} from "@pankod/refine-antd";
import { useApiUrl, useNotification } from "@pankod/refine-core";
import { BFF_KEY } from "environment";
import { ILinkedPlaces } from "interfaces";
import { useState } from "react";
import { axiosInstance } from "services/axios";

type Props = {
    closeModal: () => void;
    refreshTable: () => void;
}

export const ModalBranchOfficeMunicipiesBindMutiple: React.FC<Props> = ({ closeModal, refreshTable }) => {
    const [selectedRows, setSelectedRows] = useState<ILinkedPlaces[]>([]);
    const { tableProps, tableQueryResult } = useTable<ILinkedPlaces>({
        resource: 'v1/branch-office-place/list-unlinked-places/',
        hasPagination: true,
    });
    const rowSelection: TableProps<ILinkedPlaces>['rowSelection'] = {
        type: 'checkbox',
        onChange: (selectedRowKeys: React.Key[], selectedRows: ILinkedPlaces[]) => {
          setSelectedRows(selectedRows);
        },
      };

    const toast = useNotification();
    const apiUrl = useApiUrl();
    const handleMutipleBindMunicipieToFilial = async () => {
        if (!selectedRows.length) {
            toast.open?.({
                message: 'selecione pelo menos 1 linha para vincular à filial ao município',
                type: 'error',
            });
            return;
        }
        try {
            await axiosInstance.put(
                `${apiUrl}/v1/branch-office-place/multi-update-areaid/`,
                selectedRows.map((data) => ({
                    Id: data.BranchOfficePlace.Id,
                    AreaId: data.BranchOffice.AreaId,
                })),
                {
                    headers: {
                        'ocp-apim-subscription-key': BFF_KEY,
                        'Content-Type': 'application/json'
                    }
                }
            );
            toast.open?.({
                message: 'multi vinculações realizadas com sucesso.',
                type: 'success',
            });
        } catch (error) {
            toast.open?.({
                message: 'ocorreu um erro ao tentar realizar multi vinculações com as linhas selecionadas, tente novamente mais tarde.',
                type: 'error',
            });
        } finally {
            refreshTable();
            tableQueryResult.refetch();
            closeModal();
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Button 
            type="primary" 
            style={{ alignSelf: 'end', marginBottom: '8px', width: 'fit-content' }}
            onClick={handleMutipleBindMunicipieToFilial}
            >
                Vincular Filiais Selecionadas
            </Button>
        <Card 
            title="Verifique e selecione as filiais para fazer o vínculo com município"
            style={{ overflowY: 'scroll', maxHeight: '70vh' }}
        >
            {tableQueryResult.isLoading 
                ? <Spin tip="Carregando Filiais" /> 
                : (
                    <Table
                        {...tableProps}
                        rowSelection={rowSelection}
                        rowKey={(data) => data.BranchOffice.AreaId}
                    >
                        <Table.Column
                            dataIndex="BranchOffice"
                            key="BranchOffice"
                            title="ID da Área"
                            render={(value) => <TextField value={value.AreaId} />}
                        />
                        <Table.Column 
                            dataIndex="BranchOffice"
                            key="BranchOffice"
                            title="Filial"
                            render={(value) => <TextField value={value.AreaDescription} />}
                        />
                        <Table.Column
                            dataIndex="BranchOffice"
                            key="BranchOffice"
                            title="Estado da Filial"
                            render={(value) => <TextField value={value?.Uf} />}
                        />
                        <Table.Column
                            dataIndex="BranchOfficePlace"
                            key="BranchOfficePlace"
                            title="Id"
                            render={(value) => <TextField value={value?.Id} />}
                        />
                        <Table.Column
                            dataIndex="BranchOfficePlace"
                            key="BranchOfficePlace"
                            title="Município"
                            render={(value) => <TextField value={value?.PlaceDescription} />}
                        />
                        <Table.Column
                            dataIndex="BranchOfficePlace"
                            key="BranchOfficePlace"
                            title="Estado do Município"
                            render={(value) => <TextField value={value?.Uf} />}
                        />
                    </Table>
                )
            }
        </Card>
        </div>
    );
}